import $ from 'jquery'
export default {
  ajaxRequest: function (type, url, data, callback, failAcllback) {
    var commonUrl = 'http://glangtec.com'
    // var commonUrl = 'http://glang_admin.wwlinkage.com'
    $.ajax({
      type: type, // 'post/get'
      url: commonUrl + url,
      data: data,
      dataType: 'JSON',
      success: function (res) {
        if ((Object.prototype.toString.call(res)) === '[object Object]' || (Object.prototype.toString.call(res)) === '[object Array]') { } else {
          res = JSON.parse(res)
        }
        callback(res)
      },
      fail: function (msg) {
        failAcllback(msg)
      }
    })
  },
  ajaxFile: function (type, url, formData, callback, failAcllback) {
    var commonUrl = 'http://glangtec.com'
    // var commonUrl = 'http://glang_admin.wwlinkage.com'
    $.ajax({
      type: type,
      url: commonUrl + url,
      dataType: '',
      //                crossDomain: true,
      processData: false, // 注意：让jQuery不要处理数据
      contentType: false, // 注意：让jQuery不要设置contentType
      data: formData,
      success: function (msg) {
        var res = JSON.parse(msg)
        callback(res)
      },
      fail: function (msg) {
        failAcllback(msg)
      }
    })
  }
}
